import React from 'react'
import { boolAttr } from '@fs/zion-frontend-friends'
import { Link } from '@fs/zion-router'
import { Button, useAtSize } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import type { Person } from '../../types/persons'
import sendAnalytics from '../../services/analytics-helper'
import { getExternalBaseUrl } from '../../services/url-service'

const bannerCss = css`
  align-items: center;
  background: #ffffff;
  border-top: 1px solid #d0d3d3;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  justify-content: space-between;
  padding: 8px 16px;

  &[is-mobile] {
    flex-direction: column;
  }

  a:visited {
    color: #0181a1;
  }
`

export default function WelcomeBanner({
  person,
  analytics,
}: {
  person?: Person
  analytics: Record<string, string>
}): JSX.Element {
  const [t] = useTranslation()
  const atSize = useAtSize()

  return (
    <div css={bannerCss} is-mobile={boolAttr(atSize({ lg: false, default: true }))} data-testid="welcome-banner">
      <div>
        <span>{t('ancestors.welcome-to-discovery-page')}</span>{' '}
        <Link
          to="https://www.familysearch.org/blog/en/ancestor-discovery-page/"
          target="_blank"
          external
          onClick={() => {
            sendAnalytics({ ...analytics, link_name: 'Learn about what’s different' })
          }}
          data-testid="learn-about-whats-different"
        >
          {t('ancestors.learn-about-whats-different.action')}
        </Link>
      </div>
      <Button
        data-testid="go-to-detail-person-page"
        onClick={() => {
          sendAnalytics({ ...analytics, link_name: 'Go to Detail Person Page' })

          window.location.href = `${getExternalBaseUrl()}/tree/person/details/${person?.id}`
        }}
      >
        {t('ancestors.go-to-detail-person-page.action')}
      </Button>
    </div>
  )
}
